<script setup>
import { watch, ref } from 'vue';
import { storeToRefs } from "pinia";
import { useFVStore } from '../../../stores/formvibes';
import { getStatusFilter } from './utils';

const store = useFVStore();
const i18n = window.fvGlobalVar?.i18n;
const {generalStates} = storeToRefs(store);

const props = defineProps(['selectedStatus']);
const status = ref(getStatusFilter());
const title = ref(i18n?.select_status);

// const selectedStatus = ref([]);
</script>
<template>
    <div className="fv-form-row-label fv-font-medium">
        {{ title }}
    </div>
    <div className="fv-form-row-value">
        <el-select v-model="generalStates.queryParams.selectedStatus" placeholder="Select Status" multiple>
            <el-option
                v-for="item in status"
                :key="item.key"
                :label="item.value"
                :value="item.key"
            />
        </el-select>
    </div>
       
</template>